import { render, staticRenderFns } from "./TextToInput.vue?vue&type=template&id=9008c520&scoped=true&"
import script from "./TextToInput.vue?vue&type=script&lang=js&"
export * from "./TextToInput.vue?vue&type=script&lang=js&"
import style0 from "./TextToInput.vue?vue&type=style&index=0&id=9008c520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9008c520",
  null
  
)

export default component.exports